<script setup lang="ts">
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { projectsApi } from '@/services/api/projects';

const router = useRouter();
const form = reactive({ title: '', is_public: false });
const submitting = ref(false);

async function submit(): Promise<void> {
  if (form.title.length === 0 || submitting.value) return;
  submitting.value = true;
  try {
    const created = await projectsApi.create({ title: form.title, is_public: form.is_public });
    await router.replace({ name: 'projectForms', params: { id: String(created.id) } });
  } finally {
    submitting.value = false;
  }
}
</script>

<template>
  <section class="resource">
    <h1>New Project</h1>
    <form class="resource__form" @submit.prevent="submit">
      <label>
        <span>Title</span>
        <input v-model="form.title" type="text" required />
      </label>
      <label class="resource__checkbox">
        <input v-model="form.is_public" type="checkbox" />
        <span>Public</span>
      </label>
      <button type="submit" :disabled="submitting">
        {{ submitting ? 'Creating…' : 'Create Project' }}
      </button>
    </form>
  </section>
</template>

<style scoped src="@/assets/styles/resource-list.scss"></style>
<style scoped>
.resource__form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 32rem;
}
.resource__form input[type='text'] {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
}
.resource__checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.resource__form button {
  align-self: flex-start;
  padding: 0.5rem 1rem;
  background: #2563eb;
  color: #fff;
  border: 0;
  border-radius: 0.375rem;
  cursor: pointer;
}
</style>
